// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file accounts/accounts_payment_method_breakdown.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PaymentMethodBreakdownItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.AccountsPaymentMethodBreakdownRequest
 */
export class AccountsPaymentMethodBreakdownRequest extends Message<AccountsPaymentMethodBreakdownRequest> {
  /**
   * Start date for the report
   *
   * @generated from field: int32 start_date = 1;
   */
  startDate = 0;

  /**
   * End date for the report
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate = 0;

  constructor(data?: PartialMessage<AccountsPaymentMethodBreakdownRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsPaymentMethodBreakdownRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "end_date", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsPaymentMethodBreakdownRequest {
    return new AccountsPaymentMethodBreakdownRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsPaymentMethodBreakdownRequest {
    return new AccountsPaymentMethodBreakdownRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsPaymentMethodBreakdownRequest {
    return new AccountsPaymentMethodBreakdownRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsPaymentMethodBreakdownRequest | PlainMessage<AccountsPaymentMethodBreakdownRequest> | undefined, b: AccountsPaymentMethodBreakdownRequest | PlainMessage<AccountsPaymentMethodBreakdownRequest> | undefined): boolean {
    return proto3.util.equals(AccountsPaymentMethodBreakdownRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AccountsPaymentMethodBreakdownResponse
 */
export class AccountsPaymentMethodBreakdownResponse extends Message<AccountsPaymentMethodBreakdownResponse> {
  /**
   * List of payment method breakdown items
   *
   * @generated from field: repeated com.neulink.pharmacy.PaymentMethodBreakdownItem payment_method_breakdown_items = 1;
   */
  paymentMethodBreakdownItems: PaymentMethodBreakdownItem[] = [];

  constructor(data?: PartialMessage<AccountsPaymentMethodBreakdownResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AccountsPaymentMethodBreakdownResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "payment_method_breakdown_items", kind: "message", T: PaymentMethodBreakdownItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AccountsPaymentMethodBreakdownResponse {
    return new AccountsPaymentMethodBreakdownResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AccountsPaymentMethodBreakdownResponse {
    return new AccountsPaymentMethodBreakdownResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AccountsPaymentMethodBreakdownResponse {
    return new AccountsPaymentMethodBreakdownResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AccountsPaymentMethodBreakdownResponse | PlainMessage<AccountsPaymentMethodBreakdownResponse> | undefined, b: AccountsPaymentMethodBreakdownResponse | PlainMessage<AccountsPaymentMethodBreakdownResponse> | undefined): boolean {
    return proto3.util.equals(AccountsPaymentMethodBreakdownResponse, a, b);
  }
}

